module.exports = __webpack_public_path__ + "img/cart-icon.8d44eb0.svg";